import InvestmentDeclarationList from "./investmentDeclarationList";
export default InvestmentDeclarationList;